import { API_V1, API_V2 } from '@front-app/services/api';
import { CancelToken } from 'axios';
import { parseContents, parseContentsV2, parseContentV2 } from '../parse';
import {
	Content,
	ContentResponseV2,
	Contents,
	ContentsResponse,
	ContentsResponseV2,
	ContentsV2,
	ContentType,
	ContentV2,
	ReactionType,
} from './DiscussionModel';

export function getGroupContentsV2(
	groupId: string,
	pageNum: number,
	params: ContentPageParamsV2 = { pageSize: 10 },
	cancelToken?: CancelToken,
): Promise<ContentsV2> {
	return API_V2.get(`/group/${groupId}/contents/${pageNum}`, { params, cancelToken })
		.then(({ data }) => data as ContentsResponseV2)
		.then(parseContentsV2);
}

export function getGroupContentV2(groupId: string, contentId: string): Promise<ContentV2> {
	return API_V2.get(`/group/${groupId}/content/${contentId}`)
		.then(({ data }) => data as ContentResponseV2)
		.then(parseContentV2);
}

/**
 * @@deprecated
 */
export function getGroupContents(groupId: string, pageNum: number, params: ContentPageParams = { pageSize: 10 }, cancelToken?: CancelToken): Promise<Contents> {
	return API_V1.get(`/group/${groupId}/contents/${pageNum}`, { params: externalContentParamsToInternal(params), cancelToken })
		.then(({ data }) => data as ContentsResponse)
		.then(parseContents);
}

/**
 * @deprecated
 */
export function getGroupContent(groupId: string, contentId: string): Promise<Content> {
	return API_V1.get(`/group/${groupId}/content/${contentId}`)
		.then(({ data }) => data as Content);
}

export async function reactToContent(groupId: string, contentType: ContentType, contentId: string, reactionType: ReactionType): Promise<ContentV2> {
	return API_V2.put(`/group/${groupId}/content/${contentId}/react?contentType=${contentType}&reaction=${reactionType}`)
		.then(({ data }) => data as ContentV2);
};

export enum ContentSort {
	DATE = 'date',
	NAME = 'name',
}

export enum ContentOrdering {
	ASCENDING = 'ascending',
	DESCENDING = 'descending',
}

/**
 * @deprecated
 */
export interface ContentPageParams {
	categories?: string[]; // comma-delimited
	search?: string;
	types?: ContentType[]; // comma-delimited
	order?: ContentOrdering;
	sort?: ContentSort;
	pageSize: number;
	bufferedMessageIds?: string; // comma-delimited
	bufferedFileIds?: string; // comma-delimited
}

export interface ContentPageParamsV2 {
	category?: string[];
	search?: string;
	type?: ContentType[];
	order?: ContentOrdering;
	sort?: ContentSort;
	pageSize: number;
	bufferedMessageIds?: string; // comma-delimited
	bufferedFileIds?: string; // comma-delimited
}

/**
 * @deprecated
 */
interface ContentPageParamsInternal {
	categories?: string; // comma-delimited
	search?: string;
	types?: string; // comma-delimited
	order?: ContentOrdering;
	sort?: ContentSort;
	pageSize: number;
	bufferedMessageIds?: string; // comma-delimited
	bufferedFileIds?: string; // comma-delimited
}

/**
 * @deprecated
 */
function externalContentParamsToInternal(params: ContentPageParams): ContentPageParamsInternal {
	return {
		search: params.search,
		categories: params.categories?.join(','),
		types: params.types?.join(','),
		order: params.order,
		sort: params.sort,
		pageSize: params.pageSize,
		bufferedMessageIds: params.bufferedMessageIds,
		bufferedFileIds: params.bufferedFileIds,
	};
}
